import styled from "styled-components";

export const MainSection = styled.section`
  padding-bottom: 7rem;

  .number-div {
    width: 38px;
    height: 39px;
    border: 1px solid rgba(247, 193, 58, 1);
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 767px) {
      width: 20.626px;
      height: 21.037px;
    }
    h1 {
      font-size: 24px;
      font-style: italic;
      font-weight: 400;
      line-height: 50px;
      letter-spacing: -0.02em;
      color: rgba(255, 255, 255, 1);
      margin: 0;

      @media (max-width: 767px) {
        font-size: 12px;
      }
    }
  }

  h4 {
    font-size: 32px;
    font-style: italic;
    font-weight: 600;
    line-height: 46px;
    letter-spacing: 0em;
    color: rgba(255, 255, 255, 1);
    margin: 0;

    @media (max-width: 767px) {
      font-size: 14px;
      line-height: 20px;
    }
  }

  .question-div {
    display: flex;
    align-items: center;
    gap: 1.5rem;

    @media (max-width: 767px) {
      gap: 0.5rem;
      margin-top: 1rem;
    }
  }
`;

export const TextBoxDiv = styled.div`
  margin-top: 2rem;
  position: relative;
  width: 40.5625rem;
  height: 5.5rem;

  @media (max-width: 1600px) {
    width: 40.5625rem;
  }

  @media (max-width: 600px) {
    width: 300px;
  }

  img {
    width: 100% !important;
    height: 100% !important;
  }

  div {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: end;
    align-items: center;
    padding-right: 5rem;

    @media (max-width: 767px) {
      padding-right: 2rem;
    }
    h1 {
      margin: 0;
      color: #fff;
      font-size: 2.125rem;
      font-style: italic;
      font-weight: 400;
      line-height: 77px;
      letter-spacing: -0.02em;

      span {
        color: rgba(247, 193, 58, 1);
        font-family: "Space Crusaders" !important ;
      }

      @media (max-width: 1600px) {
        font-size: 2.125rem;
      }
      @media (max-width: 767px) {
        font-size: 16px;
      }
    }
  }
`;

export const Contentdiv = styled.div`
  margin-top: 3rem;
  @media (max-width: 767px) {
    margin-top: 1rem;
  }

  .main-question-div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
  }

  .answer-div {
    padding-left: 4rem;
    margin-top: 0.5rem;

    @media (max-width: 767px) {
      padding-left: 2rem;
      margin-top: 0rem;
    }
    h5 {
      color: rgba(255, 255, 255, 1);
      font-size: 24px;
      font-style: italic;
      font-weight: 500;
      line-height: 35px;
      letter-spacing: 0.06em;
      text-align: left;
      white-space: pre-line;
      @media (max-width: 767px) {
        font-size: 14px;
        line-height: 20px;
      }
    }
  }
`;

export const MainDiv = styled.div`
  padding: 1rem 0.5rem;
  &.open-div {
    background: rgba(69, 52, 11, 1);
  }

  @media (max-width: 767px) {
    padding: 0.3rem 0.5rem;
  }
`;
